(ns rothko.editor.tag.component)

(defn token
  [{:keys [appearance token]}]
  [:span.editor__tag.immutable
   {:class (cond-> appearance
             (or (:edited? token) (:tagged? token)) (conj :edited)
             (:system? token) (conj :system)
             (:different? token) (conj :different)
             (:previous-stage? token) (conj :previous-stage))}
   (:word token)])
